// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"SpinnerLocal_spinnerContainer__1yWhu","spinnerMain":"SpinnerLocal_spinnerMain__V-kah","spinner":"SpinnerLocal_spinner__mUlTY","load8":"SpinnerLocal_load8__EcOL5"};